import { LanguageState }  from '../../reduxTypes';
import { Reducer, Action }  from 'redux';
import ActionTypes          from '../../ActionTypes';

interface SetRecepientLanguage extends Action {
    activeLanguage: string;
}

export const dispatchActiveLanguage = (activeLanguage: string) => ({
    type: ActionTypes.SET_RECIPIENT_LANGUAGE,
    activeLanguage
});

export const clearActiveLanguage = () => ({
    type: ActionTypes.CLEAR_RECIPIENT_LANGUAGE
});

const defaultState: LanguageState = {
    activeLanguage: ''
};

const LanguageReducer: Reducer<LanguageState> = (state: LanguageState = defaultState, action: Action): LanguageState => {
    switch (action.type) {
        case ActionTypes.SET_RECIPIENT_LANGUAGE:
            const { activeLanguage } = (action as SetRecepientLanguage);
            return {
                ...state,
                activeLanguage
            };

        case ActionTypes.CLEAR_RECIPIENT_LANGUAGE:
            return {
                activeLanguage: ''
            };

        default:
            return state;
    }
};

export default LanguageReducer;



// WEBPACK FOOTER //
// ./src/components/LanguageToggle/LanguageReducer.tsx